import React, { useCallback, useMemo, useEffect, useRef } from 'react';
import DesktopDropdown from '../DesktopDropdown/DesktopDropdown';
import S from '../DesktopNavigation/DesktopNavigation.styles';
import DownChevron from '@img/icons/chevron-down.svg';
import UpChevron from '@img/icons/chevron-up.svg';
import { getDropdownItems } from '../helpers';
const DesktopNavigation = ({ item, isActive, setActiveItemId, }) => {
    const itemRef = useRef(null);
    const dropdownItems = useMemo(() => getDropdownItems(item), [item]);
    const icon = useMemo(() => (isActive ? React.createElement(UpChevron, null) : React.createElement(DownChevron, null)), [isActive]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (itemRef.current && !itemRef.current.contains(event.target)) {
                setActiveItemId(null);
            }
        };
        if (isActive) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isActive, setActiveItemId]);
    const onKeyDown = useCallback((event) => {
        switch (event.key) {
            case 'ArrowDown':
            case 'Escape':
                setActiveItemId(item.id);
                break;
            case 'ArrowUp':
                setActiveItemId(null);
                break;
            default:
                break;
        }
    }, [item.id, setActiveItemId]);
    const handleMouseEnter = useCallback(() => {
        if (dropdownItems.length > 0)
            setActiveItemId(item.id);
    }, [dropdownItems.length, item.id, setActiveItemId]);
    const handleMouseLeave = useCallback(() => {
        setActiveItemId(null);
    }, [setActiveItemId]);
    return (React.createElement(S.Item, { "data-d-active": isActive, ref: itemRef, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
        React.createElement(S.Link, { href: item.url, target: item.target, onKeyDown: onKeyDown },
            item.text,
            dropdownItems.length > 0 && icon),
        dropdownItems.length > 0 && (React.createElement(DesktopDropdown, { isActive: isActive, items: dropdownItems }))));
};
export default DesktopNavigation;
